import { useCallback, useImperativeHandle, useMemo, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { CommonService } from 'dashboard-services/services';
import { DropdownService } from 'primary-components';

import getApiConfig from 'api/ApiConfig';
import properties from 'resources/constants/properties.json';

import FilterBody from '../FilterBody';

import { useQueryClient } from '@tanstack/react-query';

const EMPTY_OBJ = {};
const EMPTY_ARRAY = [];
const MetadataFilter = ({ value, ref, ...props }) => {
  const dispatch = useDispatch(),
        valueParsed = useMemo(() => CommonService.isJson(value) ? JSON.parse(value) : value, [value]),
        { groupName, metadata = {} } = valueParsed || EMPTY_OBJ,
        filterMetadataObj = useMemo(() => {
          const filterMetadataObj = {}
          Object.entries(metadata).forEach(([key, value]) => {
            if (value !== undefined && value !== null) {
              filterMetadataObj[key] = value === "*" ? [] : (typeof value === "string" ? [value] : value)
            }
          })
          return filterMetadataObj;
        }, [metadata]),
        getApiConfigLocal = useCallback(() => dispatch(getApiConfig()), [dispatch]),
        queryClient = useQueryClient(),
        [metadataQuery, setMetadataQuery] = useState(),
        { fetchNextPage: fetchMoreKeys, isFetching: isFetchingKeys, isFetchingNextPage: isFetchingNextPageKeys, data: metadaFromApiRaw = EMPTY_ARRAY } = DropdownService.useQueryMetadata({
          queryClient,
          input: metadataQuery,
          groupName,
          useEs: properties.useEsSymbolListing === "true",
          enabled: !!groupName,
          metadata: true,
          metadatas: filterMetadataObj,
          getApiConfig: getApiConfigLocal,
          size: 20,
        }),
        groupRef = useRef()

  useImperativeHandle(ref, () => ({ 
    validateForForm: () => groupRef.current.validateForForm() && valueParsed && valueParsed.groupName && valueParsed.metadata,
    isValid: () => groupRef.current.isValid() && valueParsed && valueParsed.groupName && valueParsed.metadata
  }))

  return (
    <FilterBody
        {...props}
        fetchMoreKeys={fetchMoreKeys}
        filterMetadataObj={filterMetadataObj}
        groupName={groupName}
        groupRef={groupRef}
        isFetchingKeys={isFetchingKeys}
        isFetchingNextPageKeys={isFetchingNextPageKeys}
        isMetadata
        keysFromApiRaw={metadaFromApiRaw}
        metadata={metadata}
        setKeyQuery={setMetadataQuery}
    />
  )
}

MetadataFilter.displayName = "MetadataFilter"

MetadataFilter.propTypes = {
  value: PropTypes.any.isRequired,
}

export default MetadataFilter;